import React from "react";
import { sideBar } from "../../utils/data";
import { Link, useLocation } from "react-router-dom"; // React Router
import { renderIcon } from "./SideUtilts";

interface SideProps {
  open: boolean;
  closeSidebar: () => void;
}

export const Sidebar: React.FC<SideProps> = (props) => {
  const location = useLocation();

  const logUserOut = () => alert("logout");

  const isRouteActive = (link: string) => {
    if (link === "/dashboard") {
      return location.pathname === link;
    } else {
      return location.pathname.includes(link);
    }
  };

  return (
    <section
      className={`${
        props.open ? "tw-absolute tw-z-50" : "tw-absolute tw-hidden"
      } tw-z-[100] tw-bg-neutral-100 tw-py-[50px] tw-w-[200px] lg:tw-w-[250px] tw-h-[100vh] lg:tw-flex lg:tw-sticky tw-top-0 tw-border-solid tw-border-r-[.55px] tw-border-sec-200`}
    >
      <div className="tw-flex tw-flex-col tw-gap-[55px] tw-pl-[20px] tw-w-full tw-px-[1.5em]">
          <div className="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-gap-[20px]">
            <div className="tw-flex tw-flex-col tw-gap-[1.5em]">
              {sideBar.map((item) => (
                <Link
                  to={item.link}
                  style={{ position: "relative" }}
                  className={`${
                    isRouteActive(item.link)
                      ? `tw-w-full tw-p-[10px] tw-bg-act-blue-100  tw-rounded-[5px] 
                         tw-h-[60px] tw-flex tw-items-center`
                      : "tw-px-[.75em] tw-py-[.5em] tw-relative tw-w-full tw-h-[60px] tw-flex tw-items-center tw-justify-start"
                  } nav-link`}
                  key={item.name}
                  onClick={props.closeSidebar}
                >
                  <span className="tw-flex tw-gap-[12px]">
                    {/* <img
                      src={
                        isRouteActive(item.link)
                          ? (item.iconw as string)
                          : (item.icon as string)
                      }
                      alt={`${item.name} svg`}
                    /> */}
                    {renderIcon(item.name, isRouteActive(item.link))}
                    <p
                      className={`tw-my-0 tw-font-[400] tw-text-[1em] ${
                        isRouteActive(item.link)
                          ? "tw-text-act-blue-400"
                          : "tw-text-act-blue-700"
                      } `}
                    >
                      {item.name}
                    </p>
                  </span>
                </Link>
              ))}
            </div>

            <button
              onClick={logUserOut}
              className={
                "tw-p-[10px] tw-hidden tw-pr-[1em] tw-mt-[20px] tw-bg-red-50 tw-rounded-full tw-relative tw-w-[90%] tw-h-[50px] tw-items-center tw-justify-start tw-cursor-pointer nav-link"
              }
            >
              <span className="tw-flex tw-gap-[12px]">
                <img src={"logout"} alt="logout" />
                <p className="tw-my-0 tw-font-[400] tw-text-[1em] tw-text-red-700">
                  Logout
                </p>
              </span>
            </button>
          </div>
      </div>
    </section>
  );
};
